import { Updater, AsyncState, loadingAsyncState } from 'widgets-for-react'
import { VerpleegafdelingenFilters } from '../../utils/filtersToQueryParams'
import { ParsedPhoneNumber } from '../../utils/phoneNumber'
import { SpaarneCentrumType, SpaarneDepartmentType } from '../../utils/spaarneIcons'
import { getVerpleegafdelingenOverviewItems } from '../verpleegafdelingenOverview/verpleegafdelingenOverviewApi'

export type VerpleegafdelingenOverviewState = {
  location: string
  facilityItemsState: AsyncState<VerpleegafdelingItem[]>
}

export type VerpleegafdelingItem = {
  clinic: {
    phoneNumber: Array<ParsedPhoneNumber & { description: string; title: string }>
    visitingTimes: string
    route: string
  }
  facility:
    | { kind: 'department'; title: SpaarneDepartmentType }
    | { kind: 'centrum'; title: SpaarneCentrumType }
}

export const initialVerpleegafdelingenOverviewState = (location: string): VerpleegafdelingenOverviewState => {
  return {
    location: location ?? '',
    facilityItemsState: loadingAsyncState(() => getVerpleegafdelingenOverviewItems({ locationName: location })),
  }
}

export const VerpleegafdelingenOverviewStateUpdaters = {
  updateFacilityItemsState:
    (updater: Updater<AsyncState<VerpleegafdelingItem[]>>) =>
    (currentState: VerpleegafdelingenOverviewState): VerpleegafdelingenOverviewState => ({
      ...currentState,
      facilityItemsState: updater(currentState.facilityItemsState),
    }),
}
